<script>
  export default {
    name: 'HomeView',
  }
</script>

<template>
  <div class="home">
    <div class="video-container">
      <video autoplay muted controls loop playsinline width="100%">
        <source
          src="/visuels/videos/pascal-visite/video.mp4"
          type="video/mp4"
        />
        Ton navigateur ne supporte pas la balise vidéo.
      </video>
    </div>

    <ul class="menu-icons">
      <li>
        <router-link to="/pascal-chove">
          <img
            class="image"
            src="/visuels/menu-icons/menu-pascal-chove.jpg"
            alt=""
        /></router-link>
      </li>
      <li>
        <router-link to="/peintures">
          <img
            class="image"
            src="/visuels/menu-icons/menu-peintures.jpg"
            alt=""
          />
        </router-link>
      </li>
      <li>
        <router-link to="/sculptures">
          <img
            class="image"
            src="/visuels/menu-icons/menu-sculptures.jpg"
            alt=""
          />
        </router-link>
      </li>
      <li>
        <router-link to="/videos">
          <img class="image" src="/visuels/menu-icons/menu-videos.jpg" alt=""
        /></router-link>
      </li>
      <li>
        <router-link to="/dessins">
          <img class="image" src="/visuels/menu-icons/menu-dessins.jpg" alt=""
        /></router-link>
      </li>
      <li>
        <router-link to="/contact">
          <img class="image" src="/visuels/menu-icons/menu-contact.jpg" alt=""
        /></router-link>
      </li>
    </ul>
  </div>
</template>

<style scoped>
  .home {
    width: min(80%, 1000px);
  }

  .video-container {
    margin: 0;
  }

  video {
    width: 100%;
    height: auto;
    margin-bottom: 4em;
  }

  .menu-icons {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    width: min(100%, 1200px);
    display: grid;
    gap: 4em;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    list-style-type: none;
  }

  .image {
    cursor: pointer;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: flex;
    align-items: center;
    transition: all 0.15s ease;
  }

  .image:hover {
    padding: 0.25em;
  }

  li {
    list-style: none;
    width: 100%;
    aspect-ratio: 1/1;
  }

  /* @media (max-width: 768px) {
    .menu-icons {
      gap: 16px;
    }
  } */
</style>
